import React from "react";

// interface PropertyCardLargeProps {
//   visual: Boolean;
//   property_images?: string;
//   location?: string;
//   contract_type?: string;
//   children?: React.ReactNode;

// }

export const CardBorder = ({
  title,
  borderColor,
  bgColor='bg-[#1C2C3A]',
  location,
  children,
  ...props
}: any) => {
  return (
    <div className={`flex w-full flex-wrap border-2 ${borderColor} rounded-xl p-3 sm:p-4 md:p-6 relative`}>
      <span className={`flex justify-center items-center absolute -top-3 sm:-top-4 left-1/2 -translate-x-1/2 px-4 sm:px-6 md:px-10 ${bgColor} text-sm sm:text-base md:text-xl font-normal text-white rounded-xl whitespace-nowrap`}>
        {title}
      </span>
      {children}
    </div>
  );
};
